import { AbstractFacade } from '@goparrot/common';
import { plainToClass } from 'class-transformer';
import deepmerge from 'deepmerge';
import { ReadUserDto } from '../generated-dto';
import { UserExposeGroup } from '../interface';
export class AccountFacade extends AbstractFacade {
    constructor(config = {}, interceptors = {}) {
        super(deepmerge.all([
            {
                axiosConfig: {
                    baseURL: process.env.GOPARROT_PLATFORM_SERVICE_USER,
                },
            },
            config,
        ]), interceptors);
    }
    async resetPassword(data) {
        await this.client.post('/api/v1/account/reset-password', data);
    }
    async resetPasswordConfirm(data) {
        return plainToClass(ReadUserDto, (await this.client.post(`/api/v1/account/reset-password-confirm`, data)).data, {
            groups: [UserExposeGroup.READ],
        });
    }
    async confirmEmail(data) {
        return plainToClass(ReadUserDto, (await this.client.post('/api/v1/account/confirm-email', data)).data, {
            groups: [UserExposeGroup.READ],
        });
    }
}
//# sourceMappingURL=AccountFacade.js.map